import { render, staticRenderFns } from "./WidgetBulkStillToShip.vue?vue&type=template&id=b772ac7a"
import script from "./WidgetBulkStillToShip.vue?vue&type=script&lang=js"
export * from "./WidgetBulkStillToShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports